import { useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useAppMutation } from './useAppMutation';

interface CreateStudentPayload {
  firstName: string;
  lastName: string;
  email: string;
}

interface CreateStudentResponse {
  employeeId: string;
}

export const useCreateStudent = () => {
  const queryClient = useQueryClient();

  return useAppMutation<AxiosResponse<CreateStudentResponse>, Error, CreateStudentPayload>(
    'post',
    '/TrainingManager/students',
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['/TrainingManager/students'] });
      },
    }
  );
};
